

























































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import FecUtils from "../../utils/FecUtils";
import { RecurrenceRule, RecurenceConfig } from "@/shared/Recurrence";
import VueCronEditorBuefy from "vue-cron-editor-buefy";
import RapportMixin from "@/mixins/rapportMixin";
import ErrorMixin from "@/mixins/errorMixins";
import DateChooserRecurrence from "@/components/dateChooserRecurrence.vue";
import DateType from "@/shared/DateType";
import ConfigMixin from "@/mixins/ConfigMixin";

@Component({
  name: "RuleAdder",
  components: {
    VueCronEditorBuefy,
    DateChooserRecurrence,
  },
})
export default class RuleAdderFec extends mixins(
  ErrorMixin,
  RapportMixin,
  ConfigMixin
) {
  @Prop() public selectedRule!: RecurrenceRule;
  @Prop() public configRules!: { [key: string]: any };
  @Prop() public listRules!: RecurrenceRule[];

  public dateType = new DateType();
  public listVidages = new Array();
  public selectedRegleConfig: RecurenceConfig[] = new Array();
  public restaurantID: string = "";
  public selectedSites: Site[] = [];
  public dialogSupprRule = false;
  public msgErreurChampVide = this.$t("msgErreurChampVide").toString();
  public chooseReport = false;
  public isCsv: boolean = false;
  public isAggregate: boolean = false;
  public periode: any = "J";
  public cron: any;
  public panel: number[] = [0];
  public localRuleName: string = "";
  public initRuleName: string = "";
  public actualSite: string = "";
  public restaurantIds_to_enseigne: any = {};

  /*
   * variable permettant de traduire les différents textes du cron
   */
  public customLabel = {
    fr: {
      every: "Tous les",
      daysAt: "jour(s) à",
      at: "à",
      onThe: "Le",
      dayOfEvery: "jour, de chaque",
      monthsAt: "mois, à",
      everyDay: "Tous les",
      mon: "Lun",
      tue: "Mar",
      wed: "Mer",
      thu: "Jeu",
      fri: "Ven",
      sat: "Sam",
      sun: "Dim",
      daily: "QUOTIDIEN",
      weekly: "HEBDOMADAIRE",
      monthly: "MENSUEL",
    },
  };

  public mounted() {
    // this.restaurantID = this.fecRestaurantId.toString();
    this.selectedRegleConfig = this.configRules.FabricExportableRapportGeneral;
    this.localRuleName = this.getDisplayedRuleName(this.ruleToEdit.name);
    this.initRuleName = this.ruleToEdit.name;
    this.resIdToEnseignes(this.restaurantIds_to_enseigne);
  }

  @Watch("selectedRule", { immediate: true })
  public async onPropertyChanged(value: any, oldValue: any) {
    if (this.configRules !== undefined) {
      this.selectedRegleConfig = this.configRules["FabricExportableFec"];
    }

    if (this.ruleToEdit.id === undefined || this.ruleToEdit.id === "") {
      this.makeMeNew();
      this.ruleToEdit.fabricExportableClassName = "FabricExportableFec";
    } else {
      this.ruleToEdit.$decodedScript = JSON.parse(this.ruleToEdit.script);
      this.cron = this.ruleToEdit.cron;
      this.isCsv = this.ruleToEdit.$decodedScript.csvDownload;
      this.isAggregate = this.ruleToEdit.$decodedScript.aggregateFile;
      this.localRuleName = this.getDisplayedRuleName(this.ruleToEdit.name);
      this.initRuleName = this.ruleToEdit.name;
      this.restaurantID = this.ruleToEdit.$decodedScript.restaurant;

      await this.updateSelectedSites(this.ruleToEdit.$decodedScript.restaurant);
      this.$nextTick(() => {
        this.periode = this.ruleToEdit.$decodedScript.periode;
        this.actualSite = this.setActualSite(this.restaurantID);
      });
    }
  }

  @Watch("isCsv", { immediate: true })
  public updateIsCSV() {
    this.$set(this.ruleToEdit.$decodedScript, "csvDownload", this.isCsv);
    this.ruleToEdit.$decodedScript["csvDownload"] = this.isCsv;
  }

  @Watch("isAggregate", { immediate: true })
  public updateIsAggregate() {
    this.$set(
      this.ruleToEdit.$decodedScript,
      "aggregateFile",
      this.isAggregate
    );

    this.ruleToEdit.$decodedScript["aggregateFile"] = this.isAggregate;
  }

  public updateCron(event: any) {
    this.ruleToEdit.cron = event;
  }

  public async updateSelectedSites(restaurantId: number) {
    const site = await this.getSiteByRestaurantId(restaurantId);
    this.selectedSites = site ? [site] : [];
  }

  public async getSiteByRestaurantId(
    restaurantId: number
  ): Promise<Site | null> {
    const sites = this.sites;
    const newSite = sites.find((site) => site.restaurantId === restaurantId);
    return newSite ? newSite : null;
  }

  public selectConfig(config: any) {
    this.selectedRegleConfig = this.configRules[config];
    this.ruleToEdit.$decodedScript = {};
  }

  public updateField(value: any, champ: string) {
    if (this.ruleToEdit.$decodedScript[champ] === undefined) {
      this.ruleToEdit.$decodedScript[champ] = new Array();
      this.ruleToEdit.$decodedScript[champ].push(value);
    } else {
      this.ruleToEdit.$decodedScript[champ].push(value);
    }
  }

  public updateFieldUnique(value: any, champ: string) {
    this.ruleToEdit.$decodedScript[champ] = value;
  }

  public updateDate(event: any) {
    this.periode = event.typePeriode;
    this.$set(this.ruleToEdit.$decodedScript, "periode", this.periode);
    this.ruleToEdit.$decodedScript["periode"] = this.periode;
  }

  public updateSite(site: Site) {
    this.selectedSites = [site];
    this.ruleToEdit.$decodedScript["restaurant"] =
      this.selectedSites[0].restaurantId;
  }

  public removeAllSites() {
    this.selectedSites = [];
  }

  public getReportName(className: string) {
    return this.getReportbyClassName(className);
  }

  /**
   * Méthode pour verrifier si le nom de regle existe déjà
   */
  public isRuleNameDuplicate(name: string): boolean {
    return this.listRules.some((rule) => rule.name === name);
  }

  /*
      Méthode permettant de supprimer une règle
      */
  public async deleteRule() {
    this.$emit("deleteRule", this.ruleToEdit);
    this.dialogSupprRule = false;
  }

  /**Fonctions pour cache l'id du restaurant
   * ainsi ne garder que le nom de la regle
   */

  public getDisplayedRuleName(name: string): string {
    // const prefix = `${this.restaurantID}_`;
    // if (name.startsWith(prefix)) {
    //   return name.slice(prefix.length);
    // }
    return name;
  }

  /**
   * Methos pour ajouter l'id du restaurant au tite de la rêgle
   */
  public addRuleNameId() {
    // const prefix = `${this.restaurantID}_`;
    // if (!this.ruleToEdit.name.startsWith(prefix)) {
    this.ruleToEdit.name = this.ruleToEdit.name;
    // }
  }

  /**
   * methode d'enregistrement de la regle
   */
  public saveRule() {
    if (this.localRuleName === "") {
      const err =
        this.$t("Nom").toString() + " " + this.$t("required").toString();
      this.setErrorFromTxt(err);
      return;
    }
    if (this.ruleToEdit.cron === "" || !this.ruleToEdit.cron) {
      const err = "Cron " + this.$t("required").toString();
      this.setErrorFromTxt(err);
      return;
    }
    if (this.restaurantID === "") {
      const err = "Site " + this.$t("required").toString();
      this.setErrorFromTxt(err);
      return;
    }
    if (!this.ruleToEdit.$decodedScript.csvDownload) {
      this.$set(this.ruleToEdit.$decodedScript, "csvDownload", this.isCsv);
      this.ruleToEdit.$decodedScript["csvDownload"] = this.isCsv;
    }
    if (
      !this.ruleToEdit.$decodedScript.periode ||
      this.ruleToEdit.$decodedScript.periode === ""
    ) {
      this.$set(this.ruleToEdit.$decodedScript, "periode", this.periode);
      this.ruleToEdit.$decodedScript["periode"] = this.periode;
    }
    if (!this.ruleToEdit.$decodedScript.aggregateFile) {
      this.$set(
        this.ruleToEdit.$decodedScript,
        "aggregateFile",
        this.isAggregate
      );
      this.ruleToEdit.$decodedScript["aggregateFile"] = this.isAggregate;
    }
    if (!this.ruleToEdit.$decodedScript.restaurant) {
      this.$set(
        this.ruleToEdit.$decodedScript,
        "restaurant",
        this.restaurantID
      );
      this.ruleToEdit.$decodedScript["restaurant"] = this.restaurantID;
    }
    if (this.ruleToEdit.$decodedScript.restaurant !== this.restaurantID) {
      this.$set(
        this.ruleToEdit.$decodedScript,
        "restaurant",
        this.restaurantID
      );
      this.ruleToEdit.$decodedScript["restaurant"] = this.restaurantID;
    }
    if (!this.ruleToEdit.$decodedScript.siren) {
      this.$set(this.ruleToEdit.$decodedScript, "siren", this.getSiren());
      this.ruleToEdit.$decodedScript["siren"] = this.getSiren();
    }

    this.ruleToEdit.script = JSON.stringify(this.ruleToEdit.$decodedScript);
    const fullRuleName = `${this.localRuleName}`;

    if (
      fullRuleName !== this.initRuleName &&
      this.isRuleNameDuplicate(fullRuleName)
    ) {
      const err = this.$t("Le nom de la règle existe déjà").toString();
      this.setErrorFromTxt(err);
      return;
    }

    this.ruleToEdit.name = fullRuleName;
    this.addRuleNameId();

    if (this.ruleToEdit.id !== "") {
      this.updateRule();
    } else {
      this.addRule();
    }
    this.initRuleName = this.ruleToEdit.name;
  }

  /*
      Méthode permettant d'ajouter une nouvelle règle
      */
  private async addRule() {
    this.$emit("addRule", this.ruleToEdit);
  }

  /*
      Méthode permettant de modifier une règle
      */
  private async updateRule() {
    this.$emit("updateRule", this.ruleToEdit);
  }

  private makeMeNew() {
    this.selectedRegleConfig.map((rule: any) => {
      switch (rule.typeChamp) {
        case "java.lang.Class":
        case "java.util.UUID":
        case "eu.cashsystemes.starmanager.Periode":
          this.ruleToEdit.$decodedScript[rule.nomChamp] = "";
          break;
        case "java.util.Collection":
          this.ruleToEdit.$decodedScript[rule.nomChamp] = new Array();
          break;
      }
    });
    this.restaurantID = "";
    this.actualSite = "";
    this.localRuleName = "";
  }

  private setRestaurantID(selectedSite: string) {
    this.actualSite = selectedSite;
    const match = selectedSite.match(/- (\d+)$/);
    this.restaurantID = match ? match[1].trim() : "";
  }

  private setActualSite(resId: string): string {
    resId = resId.trim();
    const sitesFiltered: Site[] = this.sites.filter(
      (site) => site.restaurantId.toString() === resId
    );
    const enseigne = this.restaurantIds_to_enseigne[resId];
    const libelleSite: string = `${enseigne ? `${enseigne} - ` : ""}${
      sitesFiltered[0].libelle
    } - ${sitesFiltered[0].restaurantId}`.trim();
    return libelleSite;
  }

  private getSiteLibelle() {
    const mesSites =
      this.sites.length > 0 ? this.sites : JSON.parse(localStorage.societes);

    const sitesString = mesSites.map((siteobj: any) => {
      return `${
        this.restaurantIds_to_enseigne.hasOwnProperty(siteobj.restaurantId)
          ? `${this.restaurantIds_to_enseigne[siteobj.restaurantId]} - `
          : ""
      }${siteobj.libelle} - ${siteobj.restaurantId}`;
    });
    return sitesString;
  }

  private getSiren(): string | undefined {
    return FecUtils.extractSiren(this.sirets, this.restaurantID);
  }

  get fecRestaurantId(): number {
    return this.$store.getters["config/fecRestaurantId"];
  }

  get ruleToEdit(): RecurrenceRule {
    return this.selectedRule;
  }

  set ruleToEdit(rule: RecurrenceRule) {
    // emit
  }

  get sirets(): any {
    return this.$store.getters["login/sirets"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
